import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { get } from "../../../utils/api";

const usePrincipleData = (principleNo) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [principle, setPrinciple] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      try {
        setLoading(true);
        const response = await get(
          `/brsr/get/sections?id=${id}&BRSRSectionC=true&principle${principleNo}=true`,
        );
        const payload = response?.data;
        const sectionC =
          payload?.BRSRSectionC ||
          payload?.data?.BRSRSectionC ||
          payload?.data?.data?.BRSRSectionC ||
          null;
        setPrinciple(sectionC?.[`principle${principleNo}`] || null);
      } catch (error) {
        console.log(error);
        setPrinciple(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, principleNo]);

  return { loading, principle };
};

export default usePrincipleData;
